export var ContactMethodType;
(function (ContactMethodType) {
    ContactMethodType[ContactMethodType["INTERNAL"] = 1] = "INTERNAL";
    ContactMethodType[ContactMethodType["EXTERNAL"] = 2] = "EXTERNAL";
    ContactMethodType[ContactMethodType["EMAIL"] = 3] = "EMAIL";
})(ContactMethodType || (ContactMethodType = {}));
//# sourceMappingURL=contact-method.i.js.map